import { isEmpty } from '@/utils/general/browserHelper'
import React from 'react'
import DurationFilter from './DurationFilter'
import FilterCategory, { FilterLegs, RevampRtDivider } from './FilterCategory'
import LayoverDurationFilter from './LayoverFilter'

const isNarrowed = (range: any) => Number(range?.current?.max) < Number(range?.max)

const DurationFilterNew = ({
  tripDuration,
  layoverDuration,
  returnTripDuration,
  returnLayoverDuration,
  onFilterChange,
  selectedFilters,
  filterTypes,
  isRT,
  processedData,
  resetDurationFilters,
  isRevamp = false,
}: any) => {
  const onClear = () => resetDurationFilters(selectedFilters)
  const showReturnLeg = isRT && (!isEmpty(returnTripDuration) || !isEmpty(returnLayoverDuration))
  const count = [tripDuration, layoverDuration, returnTripDuration, returnLayoverDuration].reduce(
    (total: number, range: any) => total + Number(!isEmpty(range) && isNarrowed(range)),
    0
  )

  return (
    <FilterCategory count={count} isRevamp={isRevamp} title='Duration' onClear={onClear}>
      <FilterLegs isRevamp={isRevamp}>
        {!isEmpty(tripDuration) && (
          <DurationFilter
            key='tripDurationFilter'
            label='Travel Time'
            dataAttributeValue='tripDuration'
            minInHours={tripDuration.min}
            maxInHours={tripDuration.max}
            currentDuration={tripDuration.current}
            onFilterChange={onFilterChange}
            selectedFilters={selectedFilters}
            filterType={filterTypes.TRIP_DURATION}
            from={processedData?.source}
            to={processedData?.destination}
            isRT={isRT}
            isRevamp={isRevamp}
          />
        )}
        {!isEmpty(layoverDuration) && (
          <LayoverDurationFilter
            key='layoverDurationFilter'
            label='Layover duration'
            dataAttributeValue='layoverDuration'
            minInHours={layoverDuration.min}
            maxInHours={layoverDuration.max}
            currentDuration={layoverDuration.current}
            onFilterChange={onFilterChange}
            selectedFilters={selectedFilters}
            filterType={filterTypes.LAYOVER_DURATION}
            isRevamp={isRevamp}
          />
        )}

        <RevampRtDivider show={!!isRevamp && showReturnLeg} />

        {isRT && !isEmpty(returnTripDuration) && (
          <DurationFilter
            key='returnTripDurationFilter'
            label='Travel Time'
            dataAttributeValue='returnTripDuration'
            minInHours={returnTripDuration.min}
            maxInHours={returnTripDuration.max}
            currentDuration={returnTripDuration.current}
            onFilterChange={(type: any, value: any) => onFilterChange(type, value, 0, 'returnLeg')}
            selectedFilters={selectedFilters}
            filterType={filterTypes.TRIP_DURATION}
            from={processedData?.destination}
            to={processedData?.source}
            isRT={isRT}
            isRevamp={isRevamp}
          />
        )}
        {isRT && !isEmpty(returnLayoverDuration) && (
          <LayoverDurationFilter
            key='returnLayoverDurationFilter'
            label='Layover duration'
            dataAttributeValue='returnLayoverDuration'
            minInHours={returnLayoverDuration.min}
            maxInHours={returnLayoverDuration.max}
            currentDuration={returnLayoverDuration.current}
            onFilterChange={(type: any, value: any) => onFilterChange(type, value, 0, 'returnLeg')}
            selectedFilters={selectedFilters}
            filterType={filterTypes.LAYOVER_DURATION}
            isRevamp={isRevamp}
          />
        )}
      </FilterLegs>
    </FilterCategory>
  )
}

export default DurationFilterNew
